import { Box, Button, Card, CardContent, CardHeader, Checkbox, IconButton, ListItemText, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { DataField, DataOutput, DataRow, DropdownModel, EditorType, FilterAttribute } from "../../data/interfaces/sharedmodels";
import { Edit, Delete } from "@mui/icons-material";
import { LocalizationProvider, TimePicker, DatePicker } from "@mui/lab";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { useState, useEffect, useCallback } from "react";
import { batch } from "react-redux";
import magneticService from "../../data/api/magnetic.service";
import MasterListDialog from "../../modules/masterlist/childcomponents/masterlistdialog";
import { useAppDispatch, useAppSelector } from "../../stores/hooks";
import { updateEditorType } from "../../stores/magneticslice";
import { showerrormessage, showsuccessmessage } from "../../stores/notificationslice";
import { formatValue, formatValueAsReadOnly, formatValueForApi } from "../commonfunctions";
import { MenuProps } from "../commonprops";
import ConfirmDialog from "../confirmdialog";
import TablePaginationActions from "../tablepaginationactions";
import MergeGroupField from "./mergegroupfield";
import itsoService from "../../data/api/itso.service";



const EditableField = ({ field, value, fieldLookups, uniqueId, callback, isEditable }:
    { field: DataField, value: any, fieldLookups: DropdownModel[] | undefined, uniqueId: any, callback: any, isEditable: boolean }) => {
    const [currentValue, setCurrentValue] = useState(value);
    const [isEditing, setIsEditing] = useState(false);

    const [modifiedData, setModifiedData] = useState<any>(null);

    useEffect(() => {
        if (currentValue != value)
            callback(field, uniqueId, isEditing ? currentValue : value);
        if (!isEditing) {
            setCurrentValue(value);
        }
        else {
            setIsEditing(false);
        }

    })


    const handleChange = (event: any) => {
        setIsEditing(true);
        if (field.Type === "checkbox") {
            setCurrentValue(event.target.checked);
        }
        else {
            setCurrentValue(event.target.value);
        }

    }
    const handleDateChange = (value: Dayjs) => {
        setIsEditing(true);
        if (field.CustomFormat == "Time24") {
            let startHour = dayjs().startOf('day')
            setCurrentValue(value.diff(startHour, 'minute', false));
        }
        else {
            setCurrentValue(value.toDate());
        }


    }

    if ((isEditable && field.IsEditable) || uniqueId == null) {
        if (fieldLookups) {
            if (field.IsMultiSelect) {
                return (
                    <Select
                        size="small"
                        multiple
                        sx={{ width: '100%', maxWidth: '400px' }}
                        value={currentValue || [-99]}
                        renderValue={(selected) => selected.join(', ')}
                        onChange={handleChange}
                        MenuProps={MenuProps}>
                        {
                            fieldLookups.map((item) => {
                                return (
                                    <MenuItem key={item.Id} value={item.Id}>
                                        <Checkbox checked={currentValue.findIndex((a: string) => a == item.Id) > -1} />
                                        <ListItemText primary={item.Description} />
                                    </MenuItem>
                                )
                            })}


                    </Select>
                )
            }
            else {
                return (
                    <Select
                        size="small"
                        sx={{ width: '100%' }}
                        value={currentValue != null ? currentValue.toString() : "-99"}
                        onChange={handleChange}>

                        {
                            fieldLookups.map((item) => {
                                return (
                                    <MenuItem key={item.Id} value={item.Id}>{(field.LookUpShowIdDesc && item.Id != "-99") ? (item.Id + " - " + item.Description) : item.Description}</MenuItem>
                                )
                            })}


                    </Select>
                )
            }
        }
        else if (field.CustomFormat && field.CustomFormat === "Time24") {
            return (
                <div className="datepickerclass">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker ampm={false} sx={{ width: '100%' }} onChange={(value: dayjs.Dayjs) => handleDateChange(value)} defaultValue={formatValue(currentValue, field.Type, field.CustomFormat)} />
                    </LocalizationProvider>
                </div>
            )

        }
        else if (field.Type === 'date') {
            return (
                <div className="datepickerclass" >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker sx={{ width: '100%' }} onChange={(value: dayjs.Dayjs) => handleDateChange(value)} value={formatValue(currentValue, field.Type)} format="MMM D, YYYY" />
                    </LocalizationProvider>
                </div>
            )
        }
        else if (field.Type === 'checkbox') {
            return (
                <Checkbox size="small" sx={{ width: '100%' }} onChange={handleChange} checked={currentValue} value={formatValue(currentValue, field.Type)} />

            )
        }
        else {
            return (
                <TextField
                    size="small" sx={{ width: '100%' }} onChange={handleChange} value={formatValue(currentValue, field.Type)} type={field.Type} />

            )
        }
    }
    else {
        return (
            <Box component='div' sx={{ width: '100%', textAlign: 'center' }} >{currentValue && !field.IsMultiSelect && fieldLookups ?
                ((field.LookUpShowIdDesc ? currentValue + " - " : "") + fieldLookups.find(f => f.Id.toString() == currentValue)?.Description) :
                formatValueAsReadOnly(currentValue, field.Type, field.CustomFormat, field.IsMultiSelect)}</Box>
        )
    }



}


const EditableDataTable = ({ data, parent, tableid,callbackaccumulateTempData,modifiedDataInput }:
    { data: DataOutput, parent: string, tableid:number,callbackaccumulateTempData: any,modifiedDataInput:any }) => {

    const dispatch = useAppDispatch();
    const [currentData, setCurrentData] = useState<DataOutput>(data);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [needConfirmComments, setNeedConfirmComments] = useState<boolean>(true);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [isMasterListOpen, setIsMasterListOpen] = useState<boolean>(false);
    const [selectedMasterList, setSelectedMasterList] = useState<DropdownModel>({ Id: '0', Description: '' });
    const [currentMasterListCodes, setCurrentMasterListCodes] = useState<string[]>([]);
    const [findNreplaceItems, setFindNreplaceItems] = useState([]);
    const [deletedRows, setDeletedRows] = useState<number[]>([]);
    const [tempIdCounter,setTempIdCounter]=useState<number>(-100);
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const selectedNlcsBackside = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });
    const editorType = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.editorType; }
        else { return state.itsoReducer.editorType; }
    });
    const selectedVersionBackside = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    const [modifiedData, setModifedData] = useState<DataOutput>(modifiedDataInput??{
        ReadOnlyUser: true,
        Fields: data.Fields, Rows: [], CanDeleteRows: data.CanDeleteRows, IsEditable: true,
        FieldLookups: data.FieldLookups, CanAddRows: data.CanAddRows, TableId: data.TableId, Version: data.Version
    });


    useEffect(() => {
        var tempdata={...data};
        if(modifiedDataInput&&modifiedDataInput.Rows)
        {
            tempdata.Rows.push(...modifiedDataInput.Rows.filter((a: { IsDeleted: boolean; })=>a.IsDeleted==false));
        modifiedDataInput.Rows.forEach((a:DataRow)=>{
            if(a.IsDeleted&&tempdata.Rows.findIndex(b=>b.UniqueIdValue==a.OldUniqueId||b.UniqueIdValue==a.UniqueIdValue)>-1){
                tempdata.Rows.filter(b=>b.UniqueIdValue==a.OldUniqueId||b.UniqueIdValue==a.UniqueIdValue)[0].IsDeleted=true;
            }
        });
    }
        setCurrentData(tempdata);
        
        setModifedData(modifiedDataInput??{
            ReadOnlyUser: true,
            Fields: data.Fields, Rows: [], CanDeleteRows: data.CanDeleteRows,
            FieldLookups: data.FieldLookups, CanAddRows: data.CanAddRows,
            TableId: selectedTable?.Id ?? 0, Version: data.Version, IsEditable: true
        })
        setDeletedRows([]);
        setPage(0);
        if(modifiedDataInput)
            setTempIdCounter(tempIdCounter+modifiedDataInput.Rows.filter((a:DataRow)=>a.UniqueIdValue<1).length);
    }, [data]);

    const handleValueChange = useCallback((field: DataField, uniqueId: any, newValue: any) => {
        if (modifiedData.Rows.findIndex(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId) > -1) {
            let existData = { ...modifiedData };
            existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].Attributes.filter(a => a.Name == field.Name)[0].Value = newValue;
            if(existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].OldUniqueId==null){
                existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].OldUniqueId=
                existData.Rows.filter(a => a.OldUniqueId == uniqueId||a.UniqueIdValue==uniqueId)[0].UniqueIdValue;
            }
            setModifedData(existData);
        }
        else {
            const row = currentData.Rows.filter(a => a.UniqueIdValue == uniqueId)[0];
            const newRow = { ...row };
            newRow.Attributes.filter(a => a.Name == field.Name)[0].Value = formatValueForApi(newValue, field.Type, field.IsNullable);
            newRow.OldUniqueId = newRow.UniqueIdValue;
            newRow.UniqueIdValue = null;
            let existData = { ...modifiedData };
            existData.TableId = selectedTable?.Id ?? 0;
            existData.Rows.push(newRow);
            setModifedData(existData);
        }

    }, [currentData])

    const handleSaveClick = () => {
        if (modifiedData.Rows && modifiedData.Rows.length < 1) {
            dispatch(showerrormessage("There is No data has changed.."));
            return;
        }
        modifiedData.Version = selectedVersionBackside ?? "";
        modifiedData.TableId = tableid;
        let toc=null;
        let tocfromStorage=localStorage.getItem('Toc');
        if(tocfromStorage){
            toc=JSON.parse(tocfromStorage);
            const updateInput = { NlcId: selectedNlcsBackside.length > 0 ? selectedNlcsBackside[0].Id : 0, TocId: parseInt(toc.Id, 10), InputData: modifiedData };
         
        callbackaccumulateTempData(modifiedData.TableId, updateInput);
        }
        else{
            const updateInput = { NlcId: selectedNlcsBackside.length > 0 ? selectedNlcsBackside[0].Id : 0, TocId: 0, InputData: modifiedData };
         
        callbackaccumulateTempData(modifiedData.TableId, updateInput);
        }
              
    }

    const confirmDialogCallback = useCallback((confirmed: boolean, remarks: string, type: string) => {
        setDialogOpen(false);

        if (type == "Set Version") {
            if (confirmed) {
                magneticService.setCurrentVersion(selectedVersionBackside ?? "", selectedTable?.Id ?? 0, remarks, selectedNlcsBackside.length ? selectedNlcsBackside[0].Id : null).then((response) => {
                    if (response.data.IsSuccess) {
                        dispatch(showsuccessmessage(response.data.Message));
                        //callback();
                    }
                    else {
                        dispatch(showerrormessage(response.data.Message))
                    }

                });
            }
        }
        else if (type == "Delete") {
            if (confirmed) {
                let tempData = { ...modifiedData }
                let tempCurrentData = { ...currentData }
                for (let index = 0; index < deletedRows.length; index++) {
                    tempData.Rows.push(currentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]]);
                    tempCurrentData.Rows.filter(a => !a.IsDeleted)[(page * rowsPerPage) + deletedRows[index]].IsDeleted = true;
                }
                setModifedData(tempData);
                setCurrentData(tempCurrentData);
            }
            setDeletedRows([])

        }
    }, [selectedTable, selectedVersionBackside, deletedRows, modifiedData])

    const addRow = () => {
        let tempData = { ...currentData };
        setTempIdCounter(tempIdCounter+1);
        let tempRow: DataRow = { Attributes: [], UniqueIdValue: tempIdCounter, OldUniqueId: null, IsDeleted: false };
        tempData.Fields.forEach(field => {
            tempRow.Attributes.push({ Name: field.Name, Value: field.IsMultiSelect ? [] : 
                formatValueForApi(null, field.Type, field.IsNullable) })
        });
        tempData.Rows.push(tempRow);
        let tempModifiedData = { ...modifiedData };
        tempModifiedData.Rows.push(tempRow);
        setModifedData(tempModifiedData);
        setCurrentData(tempData);
        let lastPage = Math.ceil(tempData.Rows.length / rowsPerPage);
        if (page != lastPage)
            setPage(lastPage - 1);
    }

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows =
        page > 0 ? Math.max(0, (1 + page) * rowsPerPage - currentData.Rows.length) : 0;

    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number,
    ) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const showMasterList = (masterList: DropdownModel | null) => {
        if (masterList != null) {
            let field = currentData.Fields.filter(a => a.MasterList != null && a.MasterList.Id == masterList.Id)[0];
            let excludedCodes: string[] = [];
            currentData.FieldLookups.filter(a => a.FieldName == field.Name)[0].LookUpValues.forEach((item) => {
                excludedCodes.push(item.Id)

            })
            setCurrentMasterListCodes(excludedCodes);
            setSelectedMasterList(masterList);
            setIsMasterListOpen(true);
        }
    }

    const addNewMasterListItems = (items: DropdownModel[]) => {
        setIsMasterListOpen(false);
        if (items.length > 0) {
            let field = currentData.Fields.filter(a => selectedMasterList != null && a.MasterList?.Id == selectedMasterList.Id)[0];
            let fieldLookup = currentData.FieldLookups.filter(a => a.FieldName == field.Name)[0];
            let newLookupvalues = fieldLookup.LookUpValues.concat(items);
            let tempData = { ...currentData };
            tempData.FieldLookups.filter(a => a.FieldName == field.Name)[0].LookUpValues = newLookupvalues;
            setCurrentData(tempData);
        }
    }

    const editRow = (row: DataRow) => {
        let filterFields: FilterAttribute[] = [];
        currentData.Fields.filter(a => a.IsFilterField).forEach(field1 => {

            filterFields.push({ Name: field1.Name, Value: row.Attributes.filter(f => f.Name == field1.Name)[0].Value, DataType: field1.DataType })
        });
        if (parent === 'magnetic') {
            batch(() => {
                dispatch(updateMagneticFilterAtts(filterFields));
                dispatch(updateEditorType(EditorType.Form));
            });

        }
        else {
            batch(() => {
                dispatch(updateItsoFilterAtts(filterFields));
                dispatch(updateEditorType(EditorType.Form));
            });
        }

    }

    const deleteRow = (index: number) => {
        //row.IsDeleted = true;
        let tempDeletedRows = [...deletedRows];
        tempDeletedRows.push(index);
        setDeletedRows(tempDeletedRows);
        setDialogTitle('Delete');
        setDialogMessage('Confirm deletion of selected row?');
        setNeedConfirmComments(false);
        setDialogOpen(true);
    }


    const mergedGroupsHeaders = new Set();
    const mergedGroups = new Set();

    return (
        <Box component='div'>
            <TableContainer component={Paper} >
                {currentData.Fields && currentData.Fields.length > 0&&currentData.Rows ?
                    <Table sx={{ minWidth: 500 }} stickyHeader size="small" aria-label="simple table">
                        <TableHead>
                            <TableRow>

                                {

                                    currentData.Fields.filter(a => a.IsBrowsable).map((field) => {
                                        let attField = currentData.Fields.filter(a => a.Name == field.Name)[0];
                                        if (attField.MergeGroup != null && !mergedGroupsHeaders.has(attField.MergeGroup)) {

                                            mergedGroupsHeaders.add(attField.MergeGroup);
                                            return (
                                                <TableCell
                                                    sx={{ minWidth: '120px' }}
                                                    align="center"
                                                    key={field.Name}
                                                >
                                                    {field.MergeGroup ?? field.Name}
                                                    {field.MasterList != null && currentData.IsEditable ? <Button sx={{ m: 1, ml: 2 }} variant="outlined" onClick={() => showMasterList(field.MasterList)}>Add</Button> : null}
                                                </TableCell>
                                            );
                                        } else if (attField.MergeGroup != null && mergedGroupsHeaders.has(attField.MergeGroup)) {

                                            return null;
                                        } else {
                                            return (
                                                <TableCell sx={{ minWidth: '120px' }} align="center" key={field.Name}>   {field.Description ?? field.Name}
                                                    {field.MasterList != null && currentData.IsEditable ? <Button sx={{ m: 1, ml: 2 }} variant="outlined" onClick={() => showMasterList(field.MasterList)}>Add</Button> : null}</TableCell>

                                            )
                                        }

                                    })

                                }

                                {selectedTable?.EditorType == EditorType.TableOrForm ? <TableCell align="center">Edit</TableCell> : null}
                                {selectedTable?.CanDeleteRows&&(currentData&& currentData.IsEditable )? <TableCell width={1} align="center">Delete</TableCell> : null}

                            </TableRow>
                            <TableRow >

                            </TableRow>
                        </TableHead>

                        <TableBody>
                            <TableCell padding="checkbox">

                            </TableCell>
                            {(rowsPerPage > 0
                                ? currentData.Rows.filter(a => !a.IsDeleted).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : currentData.Rows.filter(a => !a.IsDeleted)).map((row, index) => {
                                    return (

                                        <TableRow
                                            key={row.UniqueIdValue}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >

                                            {
                                                currentData.Fields.filter(a => a.IsBrowsable).map((field) => {
                                                    let attField = currentData.Fields.filter(a => a.Name == field.Name)[0];
                                                    if (attField.ToggleField && row.Attributes.filter(a => a.Name == attField.ToggleField)[0].Value == attField.ToggleCondition) {

                                                        return (<TableCell key={field.Name + row.UniqueIdValue} sx={{ textAlign: 'center' }}>-</TableCell>)
                                                    }
                                                    else if (attField.MergeGroup != null) {

                                                        let mergedFields = currentData.Fields.filter(f => f.MergeGroup === attField.MergeGroup);
                                                        let values = mergedFields.map(f => row.Attributes.find(a => a.Name === f.Name));

                                                        if (field === mergedFields[0]) {

                                                            return (
                                                                <TableCell key={field.Name + row.UniqueIdValue}>
                                                                    <MergeGroupField title={field.MergeGroup} mergeFields={mergedFields} values={values || []} key={field.Name + row.UniqueIdValue} uniqueIdValue={row.UniqueIdValue} callback={handleValueChange} ></MergeGroupField>
                                                                </TableCell>
                                                            );
                                                        } else {

                                                            return null;
                                                        }
                                                    }
                                                    else {
                                                        return (
                                                            <Tooltip title={field.ToolTip}>
                                                                <TableCell>
                                                                    <EditableField isEditable={currentData.IsEditable} key={field.Name + row.UniqueIdValue} field={field} value={row.Attributes.filter(a => a.Name == field.Name)[0].Value}
                                                                        uniqueId={row.UniqueIdValue} callback={handleValueChange}
                                                                        fieldLookups={currentData.FieldLookups.findIndex(a => a.FieldName == field.Name) > -1 ?
                                                                            currentData.FieldLookups[currentData.FieldLookups.findIndex(a => a.FieldName == field.Name)].LookUpValues : undefined} /></TableCell></Tooltip>
                                                        )
                                                    }
                                                })
                                            }
                                            {selectedTable?.EditorType == EditorType.TableOrForm && currentData.IsEditable ? <TableCell><IconButton onClick={() => editRow(row)}><Edit /></IconButton></TableCell> : null}
                                            {(selectedTable?.MinRowCount == null || currentData.Rows.filter(a => !a.IsDeleted).length > selectedTable?.MinRowCount) && selectedTable?.CanDeleteRows && currentData.IsEditable ? <TableCell width={1} align="center"><IconButton onClick={() => deleteRow(index)}><Delete /></IconButton></TableCell> : null}

                                        </TableRow>
                                    )
                                })
                            }
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 53 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10,20, 40, 60, { label: 'All', value: -1 }]}
                                    count={currentData.Rows.filter(a => !a.IsDeleted).length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: {
                                            'aria-label': 'rows per page'

                                        }
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table> : <Typography sx={{ m: 2 }} variant="h6">No data found for the current selection.</Typography>}


            </TableContainer>
            <Box sx={{ mt:2, display: 'flex', justifyContent: 'space-between' }}>
                                        {(selectedTable?.MaxRowCount == null || currentData.Rows.filter(a => !a.IsDeleted).length < selectedTable?.MaxRowCount) && currentData.CanAddRows && currentData.IsEditable ? <Button variant="outlined" onClick={addRow}>Add More</Button> : <div/>}
                                        {currentData && currentData.IsEditable ? <Button sx={{ mr: 2 }} variant="contained" onClick={handleSaveClick}>Submit</Button> : null}

                                    </Box>
            <ConfirmDialog needComments={needConfirmComments} isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={confirmDialogCallback} />
            <MasterListDialog isopen={isMasterListOpen} listType={selectedMasterList}
                excludedCodes={currentMasterListCodes} callback={addNewMasterListItems} />
        </Box>
    )
}







export default function ButtonFieldPopup({ parent, heading, tableid, value, callbackaccumulateTempData }:
    { parent: string, heading: string | undefined, tableid: string, value: any, callbackaccumulateTempData: any }) {

    const selectedNlcs = useAppSelector((state) => state.itsoReducer.selectedNlcs);
    const selectedVersion = useAppSelector((state) => state.itsoReducer.selectedVersion);
    const filterFields = useAppSelector((state) => state.itsoReducer.filterAttributes);
    const [data, setData] = useState<any>({ Fields: [], Rows: [], VersionDetails: null, FieldGroups: [], FieldLookups: [], CanAddRows: false });
    const [modifiedData,setModifedData]=useState<any>(null);
    
    useEffect(() => {
        if (selectedVersion) {
           
            
                itsoService.getdata(Number(tableid),
                    (!0 && selectedNlcs.length > 0) ? selectedNlcs[0].Id : undefined, selectedVersion, filterFields,
                    EditorType.Table).then((response) => {
                        if (response && response.data) {
                            if (value&&value.InputData.Rows) {
                                response.data.Rows.forEach((row:DataRow)=>{
                                    if(value.InputData.Rows.flatMap((a:DataRow)=>a.OldUniqueId).indexOf(row.UniqueIdValue)>-1)
                                        row.Attributes=value.InputData.Rows.filter((a:DataRow)=>a.OldUniqueId==row.UniqueIdValue)[0].Attributes;
                                });
                                value.InputData.Rows.filter((a:DataRow)=>a.UniqueIdValue!=null&&a.UniqueIdValue<1&&a.OldUniqueId==null).forEach((row:DataRow)=>{
                                    response.data.Rows.push(row);
                                })
                                setModifedData(value.InputData);
                                setData(response.data);
                                
                                
                            }
                            else{
                                setData(response.data);
                                
                            }
                        }
                        else {
                            setData({ Fields: [], Rows: [], VersionDetails: null, FieldGroups: [], FieldLookups: [], TypeLookups: [], CanAddRows: false });
                        }

                    })
                  
            

        }
        else {
            setData({ Fields: [], Rows: [], VersionDetails: null, FieldGroups: [], FieldLookups: [], TypeLookups: [], CanAddRows: false });
        }
    }, []);



    return (
        <Card>
            <CardHeader sx={{ p: 1 }} />

            <CardContent>
                {heading == undefined ? '' : <EditableDataTable parent={parent} tableid={Number(tableid)} data={data} modifiedDataInput={modifiedData} callbackaccumulateTempData={callbackaccumulateTempData} />}
            </CardContent>
        </Card>
    );
}

function updateMagneticFilterAtts(filterFields: FilterAttribute[]): any {
    throw new Error("Function not implemented.");
}
function updateItsoFilterAtts(filterFields: FilterAttribute[]): any {
    throw new Error("Function not implemented.");
}

